import { base } from './_base';

const { apiPrefix, HOST, ENV, ProdENV, isProduct } = base;

let HOST_1 = isProduct ? 'https://autoapi.autohome.com.cn/xcds/dsgg' : 'http://tpopcenter.mall.autohome.com.cn';

let HOST_2 = isProduct
  ? "https://autoapi.autohome.com.cn/xcds/dsgg"
  : "http://amscenterdev.yz.test.autohome.com.cn";

let HOST_3 = ENV ? 'api' : 'https://sou.api.autohome.com.cn';

let pvHOST = isProduct
  ? "//apitrade.mall.autohome.com.cn"
  : "//test-gw-trade.mall.autohome.com.cn";

let getcarvrinfobyseriesidHost = isProduct
  ? "//autoapi.autohome.com.cn"
  : "//apigateway.corpautohome.com";

// 秒杀成功结果信息接口
const getcarvrinfobyseriesid = () => {
  const category = isProduct ? "car" : "demo";
  return `${getcarvrinfobyseriesidHost}/znjs/jssj/v1/vr/getcarvrinfobyseriesid?_appid=qcjr&category=${category}`;
};

export default {
  getShopByDomain: `${HOST_1}/provider/getShopByDomain`, // 根据商家id查询商家信息-c端
  getShopHeader: `${HOST_2}/v3/shopHead/get`, // 店铺api-页头信息接口
  getModelView: `${HOST_2}/v3/shopModelView/getModelView`, // 店铺api-主体信息接口
  getGoodsList: `${HOST_3}/v3/carsearch/goodsAndNewCar`, // 商城-新车与车品商品合并
  getcarvrinfobyseriesidApi: getcarvrinfobyseriesid(), // 获取车系360度链接
  getSeriesPic:
    "//autoapi.autohome.com.cn/zxtd/cpkcpx/v2carpicseriespnglogobyserieslist", // 获取车系透明图
  cmsCommonArticlesList: `${pvHOST}/v3/shopdecorate/cms_common_articles_list`, // 前沿资讯数据
  getArticlesCommon: `${pvHOST}/v3/shopdecorate/GetArticlesCommon`, // 品牌新闻数据
  getHotData: `${pvHOST}/v3/shopdecorate/get_hot_data`, // 获取评论数、点赞数、查看数
};
